import { useContext } from 'react';

import { QSetReviewSubtaskContext } from './qset-review-subtask-provider';

export default function useQSetReviewSubtask() {
  const context = useContext(QSetReviewSubtaskContext);

  if (!context) {
    throw new Error('useQSetReviewSubtask must be used within a QSetReviewSubtaskProvider');
  }

  return context;
}
